<template>
  <transition name="OverlayMenu-">

    <div class="OverlayMenu"
      v-show="menu.isVisible">

      <div class="OverlayMenu-items">

        <router-link class="OverlayMenu-item"
          v-for="(item, index) in items"
          :key="index"
          :to="item.path"
          @click.native="selectItem">

          <container>

            {{ item.title }}

          </container>

        </router-link>

      </div>

      <div class="OverlayMenu-footer">

        <container>

          <p class="t-caps-md c-grey-xxlt">
            Contact Benj+Sara
          </p>

          <a class="t-text-sm c-grey-lt"
            :href="`mailto:${global.site.email.value}`">
            {{ global.site.email.label }}
          </a>

<!--          <a class="t-text-sm c-grey-lt"
            :href="`tel:${global.site.phone.value}`">
            {{ global.site.phone.label }}
          </a>
-->
        </container>

      </div>

    </div>

  </transition>
</template>

<script>
export default {
  name: 'OverlayMenu',

  computed: {
    window () { return this.$store.state.window },
    menu () { return this.$store.state.menu },
    items () {
      return this.global.menu
    }
  },

  watch: {
    'menu.isVisible' () {
      this.$store.dispatch('window/setPreventScroll', this.menu.isVisible)
    },

    'window.width' () {
      if (this.window.width >= 600) {
        this.$store.dispatch('menu/hide')
      }
    }
  },

  methods: {
    selectItem () {
      this.$store.dispatch('menu/toggle')
    }
  }
}
</script>

<style>
@import 'properties';

.OverlayMenu {
  position: fixed;
  z-index: 900;
  top: 96px;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--unit) 0;
  overflow-y: scroll;
  background-color: var(--c-black-alt);
  -webkit-font-smoothing: antialiased;
}

.OverlayMenu--enter-active,
.OverlayMenu--leave-active {
  transition: opacity 0.25s ease;
  opacity: 1;
}

.OverlayMenu--enter,
.OverlayMenu--leave-to {
  opacity: 0;
}

/* Hide below layers on overscroll */
.OverlayMenu::before,
.OverlayMenu::after {
  display: block;
  content: '';
  position: fixed;
  right: 0;
  left: 0;
  height: 100%;
  background-color: var(--c-black-alt);
}

.OverlayMenu::before {
  bottom: 100%;
}

.OverlayMenu::after {
  top: 100%;
}

.OverlayMenu-items {
}

.OverlayMenu-item {
  display: block;
  text-align: right;
  font-size: 36px;
  line-height: 1.6;
  font-weight: 200;
  color: var(--c-grey-xlt2);
  cursor: pointer;
}

.OverlayMenu-item:hover {
  color: var(--c-blue);
}

.OverlayMenu-footer {
  text-align: right;
  color: white;
  line-height: 24px;
}

.OverlayMenu-footer * {
  line-height: 24px;
}

.OverlayMenu-footer a {
  display: block;
  color: inherit;
}

.OverlayMenu-footer a:hover {
  color: var(--c-blue) !important;
}
</style>



// WEBPACK FOOTER //
// OverlayMenu.vue?88b20c08